import type { referrers } from './constants/referrers';

export enum ProductUpsellTypeEnum {
  observe = 'observe',
  ask = 'ask',
  multi = 'multi',
}

export type Referrer = (typeof referrers)[number];
